import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["pricingSection", "billingSection", "upsellsSection", "standardCard", "quoteCard", "standardCheck", "quoteCheck"]

  connect() {
    this.toggle()
  }

  toggle() {
    // Check if the quote_request radio is selected
    const quoteRequestRadio = this.element.querySelector('input[name="service_type_selector"][value="quote_request"]')
    const quoteRequestCheckbox = this.element.querySelector('input[name="offered_service[quote_request]"][type="checkbox"]')

    const isQuoteRequest = quoteRequestRadio?.checked

    // Update the hidden checkbox to match the radio selection
    if (quoteRequestCheckbox) {
      quoteRequestCheckbox.checked = isQuoteRequest
    }

    // Show/hide sections based on selection
    if (isQuoteRequest) {
      this.hideSections()
    } else {
      this.showSections()
    }

    // Update card styling
    this.updateCardStyles(isQuoteRequest)
  }

  hideSections() {
    if (this.hasPricingSectionTarget) {
      this.pricingSectionTarget.classList.add('hidden')
    }
    if (this.hasBillingSectionTarget) {
      this.billingSectionTarget.classList.add('hidden')
    }
    if (this.hasUpsellsSectionTarget) {
      this.upsellsSectionTarget.classList.add('hidden')
    }
  }

  showSections() {
    if (this.hasPricingSectionTarget) {
      this.pricingSectionTarget.classList.remove('hidden')
    }
    if (this.hasBillingSectionTarget) {
      this.billingSectionTarget.classList.remove('hidden')
    }
    if (this.hasUpsellsSectionTarget) {
      this.upsellsSectionTarget.classList.remove('hidden')
    }
  }

  updateCardStyles(isQuoteRequest) {
    if (!this.hasStandardCardTarget || !this.hasQuoteCardTarget) return

    const standardCard = this.standardCardTarget
    const quoteCard = this.quoteCardTarget

    if (isQuoteRequest) {
      // Quote request selected
      standardCard.classList.remove('border-primary-500', 'bg-primary-50', 'dark:bg-primary-900/20', 'ring-2', 'ring-primary-500')
      standardCard.classList.add('border-gray-200', 'dark:border-gray-700', 'hover:border-gray-300', 'dark:hover:border-gray-600')

      quoteCard.classList.remove('border-gray-200', 'dark:border-gray-700', 'hover:border-gray-300', 'dark:hover:border-gray-600')
      quoteCard.classList.add('border-amber-500', 'bg-amber-50', 'dark:bg-amber-900/20', 'ring-2', 'ring-amber-500')

      if (this.hasStandardCheckTarget) {
        this.standardCheckTarget.classList.add('invisible')
      }
      if (this.hasQuoteCheckTarget) {
        this.quoteCheckTarget.classList.remove('invisible')
      }
    } else {
      // Standard service selected
      standardCard.classList.remove('border-gray-200', 'dark:border-gray-700', 'hover:border-gray-300', 'dark:hover:border-gray-600')
      standardCard.classList.add('border-primary-500', 'bg-primary-50', 'dark:bg-primary-900/20', 'ring-2', 'ring-primary-500')

      quoteCard.classList.remove('border-amber-500', 'bg-amber-50', 'dark:bg-amber-900/20', 'ring-2', 'ring-amber-500')
      quoteCard.classList.add('border-gray-200', 'dark:border-gray-700', 'hover:border-gray-300', 'dark:hover:border-gray-600')

      if (this.hasStandardCheckTarget) {
        this.standardCheckTarget.classList.remove('invisible')
      }
      if (this.hasQuoteCheckTarget) {
        this.quoteCheckTarget.classList.add('invisible')
      }
    }
  }
}
